<ion-toolbar class="py-8" color="white">
  <ion-buttons slot="start">
    <ion-menu-button color="primary" [autoHide]="false" data-cy="Open menu"></ion-menu-button>
  </ion-buttons>
  <ion-title>{{ titleKey | translate | uppercase }}</ion-title>
</ion-toolbar>
<ui-current-cdc [project]="(projects$ | async) || undefined" *ngIf="showCurrentProject"></ui-current-cdc>
